import { asCard } from "#webapp/src/components/card";
import { sortDataSources } from "#webapp/src/util/data-source.util";
import { PostMessageManager } from "#webapp/src/util/post-message.util";
import { Button, Link } from "@clockwise/design-system";
import { webappDefaultWindowName } from "@clockwise/web-commons/src/constants/route.constants";
import { getUrlForFeature } from "@clockwise/web-commons/src/util/routes.util";
import React from "react";
import { useSelector } from "react-redux";
import { createFragmentContainer } from "react-relay";
import { IReduxState } from "../../state/reducers/root.reducer";
import { chromePersonalCalendarFragments } from "./ChromePersonalCalendar.gql";
import { IProps } from "./ChromePersonalCalendarTypes";

const openAccountPreferences = () => {
  window.open(getUrlForFeature("accountPreferences"), webappDefaultWindowName);
};

const ChromePersonalCalendarComponent = ({ user, org }: IProps) => {
  const windowUserEmail = useSelector((state: IReduxState) => state.webExtension.windowUserEmail);
  const sortedDataSources = sortDataSources(user.dataSources.edges, org.domains);
  const workCalendar =
    (sortedDataSources.work && sortedDataSources.work.length && sortedDataSources.work[0].name) ||
    "";
  const personalCalendar = sortedDataSources.other.find((ds) => ds.name === windowUserEmail);

  const handleClose = () => {
    PostMessageManager.closeSidebar(true);
  };

  return (
    <div className="cw-body-base cw-p-4">
      {personalCalendar &&
      personalCalendar.syncTargets &&
      personalCalendar.syncTargets.length > 0 ? ( // is syncing
        <div>
          Clockwise is automatically syncing {personalCalendar.name} to your work email{" "}
          {workCalendar}. View or edit your{" "}
          <Link onClick={openAccountPreferences}>connected calendars</Link> from Settings.
          <div className="cw-mt-2">
            <Button variant="text" onClick={handleClose}>
              Hide Extension
            </Button>
          </div>
        </div>
      ) : (
        <div>
          You have connected this calendar to Clockwise, but syncing is currently turned off. View
          or edit your <Link onClick={openAccountPreferences}>connected calendars</Link> from
          Settings.
          <div className="cw-mt-2">
            <Button variant="text" onClick={handleClose}>
              Hide Extension
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export const ChromePersonalCalendar = createFragmentContainer<IProps>(
  asCard<IProps>(ChromePersonalCalendarComponent),
  chromePersonalCalendarFragments,
);
